// src/services/initializeTokenService.ts
import { tokenService } from './tokenService';
import { authService } from './authService';

/**
 * Initialize the token service during application startup.
 * This should be called once when the application loads.
 */
export const initializeTokenService = (): void => {
  // Only initialize if the user is already authenticated
  if (authService.isAuthenticated()) {
    // Start the token refresh monitoring
    tokenService.startTokenRefreshMonitor();

    // Run a bootstrap sync so an already-expired session is handled immediately.
    tokenService.syncTokenState();
  }
};
